// @flow
import BoxInput from "./BoxInput";

export default BoxInput;
